import React, {useState,useEffect,useRef} from 'react'
import { Form, Card, Button, Row, Col } from 'react-bootstrap';
import { BiUpload } from 'react-icons/bi';
import VendorAppBar from '../Vendor/VendorAppBar';
import { COLORS } from '../colors';
import axios from 'axios';
import '../EditableCard.css';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import api from '../../Services/api';
import { Category, Timer } from '@mui/icons-material';
import { FaFileDownload } from "react-icons/fa";
import { MdFileOpen, MdRemoveRedEye, MdDelete, MdEditDocument } from "react-icons/md";
import { CardActionArea } from '@mui/material';



const currentYear = new Date().getFullYear();

const years = Array.from({ length: currentYear - 2020 + 1 }, (x, i) => 2020 + i);

 const titles= [
    {title: "GST Certificate", Category : "Governance"},
    {title: "Trade Licence Registration And Renewal",Category:"Social"},
   {title: "Factory Licence",Category:"Governance"},
     {title:"Building Plan Layout",Category:"Governance"},
     {title:"Stability Certificate",Category:"Governance"},
     {title:"Concern To Establishment",Category:"Governance"},
     {title:"Concern To Operations",Category:"Governance"},
    {title: "Fire Advisory",Category:"Environmental"},
    {title: "Fire NOC",Category:"Environmental"},
     {title:"Environment Clearance",Category:"Environmental"},
     {title:"Medical Hospital Certificate",Category:"Social"},
     {title:"PSARA Licence",Category:"Governance"},
     {title:"FSSAI Licence",Category:"Social"},
    {title: "Manager Change",Category:"Governance"},
     {title:"EPFO Allotment Copy",Category:"Social"},
     {title:"ESIC Allotment Copy",Category:"Social"},
    {title: "PTax RC Number",Category:"Governance"},
     {title:"PT EC Number",Category:"Governance"},
     {title:"LWF Number",Category:"Social"},
     {title:"CLRARC",Category:"Social"},
     {title:"SandCERC",Category:"Social"},
    {title: "BOCWRC",Category:"Social"},
    {title:"ISMWRC",Category:"Social"},
   {title:"Apprenticeship Registration",Category:"Social"},
 {title:"NEEMNAPS Registration",Category:"Social"},
 {title:"WCPolicy Number",Category:"Governance"},
 {title:"Standing Order",Category:"Governance"},
 {title:"Shift Approval",Category:"Social"},
 {title:"Display Of Notice Containing Abstracts",Category:"Social"},
 {title:"Hazardous waste Disposal Approval",Category:"Environmental"},
 {title:"Biomedical Waste Approval",Category:"Environmental"},
 {title:"Boiler Amendment",Category:"Environmental"},
 {title:"Analysis Fee Payment",Category:"Governance"},
 {title:"Compliance Certificate",Category:"Governance"},
 {title:"ESG Policy",Category:"Governance"},
 {title:"Policy On POSH Act 2013",Category:"Governance"},
 {title:"POSH Internal Committee",Category:"Social"},


 {title:"Company Incorporation Number",Category:"Governance"},
{title:"Environmental Policy",Category:"Governance"},
{title:"HumanRights Policy",Category:"Governance"},
{title:"Diversity Policy",Category:"Governance"},
{title:"Whistle blower Policy",Category:"Governance"},
{title:"Audit Committee",Category:"Governance"},
{title:"Nomination And Remuneration Committee",Category:"Governance"},
{title:"CSR Committee",Category:"Governance"},
{title:"CSR Policy And Strategy",Category:"Governance"},
{title:"Risk Management Committee",Category:"Governance"},
{title:"Sustainability Committee",Category:"Governance"},
{title:"Code Of Business Ethics And Conduct",Category:"Governance"},
{title:"Policy On Related Party Transactions Disclosed",Category:"Governance"},


      ];

const MasterDataClient = () => {
      const initialState = titles.map(title => ({ value: '', fileUrl: '',validDate:'',noOfWorkers:'', validation: 0, AssessorRemark: '',unit:'' ,clientRemark: '', na: false, qId: '', fee:'',editing: false, isFileModified: false }));
      const [cardStates, setCardStates] = useState(initialState);
      const fileInputRefs = useRef(Array(titles.length).fill(null).map(() => React.createRef()));
      const [userId, setUserId] = useState('');
      const [userType, setUserType] = useState('');
     const [countValidation1, setCountValidation1] = useState(0);
       const [countValidation2, setCountValidation2] = useState(0);
       const [countValidation3, setCountValidation3] = useState(0);
          const[loading,setLoading] = useState(true);
      const [snackbarOpen, setSnackbarOpen] = useState(false);
      const [snackbarMessage, setSnackbarMessage] = useState('');
      const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
       const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
        const [uploadStatus, setUploadStatus] = useState(Array(titles.length).fill('upload'));
        const [initialCardStates, setInitialCardStates] = useState(initialState);
       const [filter, setFilter] = useState("");
       
  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem('user'));

    if (userData && userData.id) {
      setUserId(userData.id);
      setUserType(userData.type);

    }
  }, []);

  useEffect(() => {
   
    if (userType === 'client') {

      fetchCompanyData(userId);
    }
 
 
   
  }, [userId]);





  const fetchCompanyData = async (userId) => {
  
    try {
      const response = await api.client.getClientMasterData(userId);
     
      const fieldNames = [
  
    "GSTCertificate",
    "TradeLicenceRegAndRenewal",
    "FactoryLicence",
    "BuildingPlanLayout",
    "StabilityCertificate",
    "ConcernToEstablishment",
    "ConcernToOperations",
    "FireAdvisory",
    "FireNOC",
  
    "EnvironmentClearance",
    "MedicalHospitalCertificate",
    "PSARALicence",
    "FSSAILicence",
    "ManagerChange",
    "EPFOAllotmentCopy",
    "ESICAllotmentCopy",
    "PTaxRCNumber",
    "PTECNumber",
    "LWFNumber",
    "CLRARC",
    "SandCERC",
    "BOCWRC",
"ISMWRC",
"ApprenticeshipRegistration",
"NEEMNAPSRegistration",
"WCPolicyNumber",
"StandingOrder",
"ShiftApproval",
"DisplayOfNoticeContainingAbstracts",
"HazardouswasteDisposalApproval",
"BiomedicalWasteApproval",
"BoilerAmendment",
"AnalysisFeePayment",
"ComplianceCertificate",
"ESGPolicy",
"PolicyOnPOSHAct2013",
"POSHInternalCommittee",
"CompanyIncorporationNumber",
"EnvironmentalPolicy",
"HumanRightsPolicy",
"DiversityPolicy",
"WhistleblowerPolicy",
"AuditCommittee",
"NominationAndRemunerationCommittee",
"CSRCommittee",
"CSRPolicyAndStrategy",
"RiskManagementCommittee",
"SustainabilityCommittee",
"CodeOfBusinessEthicsAndConduct",
"PolicyOnRelatedPartyTransactionsDisclosed",

    
  
  ];
      
      
      if (response.status === 200) {
        
        const responseData = response.data.data;
        console.log(responseData,"data1")
        let validation1 = 0;
        let validation2 = 0;
        let validation3 = 0;
        const updatedCardStates = fieldNames.map((fieldName,index) => {
          const fieldData = responseData[fieldName] || {};
          console.log(fieldData,"data")
          let background = COLORS.light;
  
          const validation = fieldData.validation;
  
          if (validation === 1) {
            background = COLORS.bggray;
            validation1 += 1;
          } else if (validation === 2) {
            background = COLORS.success;
            validation2 += 1;
          } else if (validation === 3) {
            background = COLORS.danger;
            validation3 += 1;
          }
          else{
            background = COLORS.light
          }
  
          const fileUrl = fieldData.fileUrl;
          const fileName = fileUrl ? fileUrl.substring(fileUrl.lastIndexOf('/') + 1) : '';
          console.log("title",titles.title)
          const { title ,Category} = titles[index];
          
          return {
            key: fieldName,
            title: title,
            Category: Category,  // Keep track of the field name
          value: fieldData.value || '',
          unit:fieldData.Unit ||'',
          fileUrl: fieldData.fileUrl || '',
          fileName: fileName,
          fee: fieldData.fee,
          validation: fieldData.validation || 0,
          validDate: fieldData.validDate || '',
          noOfWorkers: fieldData.noOfWorkers || '',
          AssessorRemark: fieldData.AssessorRemark || '',
          clientRemark: fieldData.clientRemark || '',
          na: fieldData.na || false,
          editing: fieldData.editing || false,
          qId: fieldData.qId || '',
          background: background,
           
          };
        });
        
        const updatedUploadStatus = updatedCardStates.map(card => 
          card.fileUrl ? 'uploaded' : 'upload'
        );
        setCardStates(updatedCardStates);
        setUploadStatus(updatedUploadStatus);
        setInitialCardStates(updatedCardStates);
        setCountValidation1(validation1);
        setCountValidation2(validation2);
        setCountValidation3(validation3);
        setLoading(false)
      }
      else if (response.status === 404) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message)
        setCardStates(initialState);
        setLoading(false)
      }
      else if (response.status === 500) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setCardStates(initialState);
        setLoading(false)
      }
      else if (response.status === 400) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setCardStates(initialState);
        setLoading(false)
      }
      else {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage("Error fetching details");
        setCardStates(initialState);
        setLoading(false)
      }


    } catch (error) {
      console.error('Error fetching vendor data:', error);
    }
  };


  const handleFileChange = (e, index) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const updatedCardStates = [...cardStates];
      updatedCardStates[index].fileUrl = '';
      updatedCardStates[index].fileName = selectedFile.name;
      updatedCardStates[index].clientRemark = ''
      updatedCardStates[index].isFileModified = false;
      setCardStates(updatedCardStates);
      const updatedUploadStatus = [...uploadStatus];
      updatedUploadStatus[index] = 'upload';
      
      setUploadStatus(updatedUploadStatus);
    }
   
  };
  const handleFileUpload = async (index, title) => {
    const selectedFile = fileInputRefs.current[index].current.files[0];
    
    if (!selectedFile) {
   
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage('No file selected!');
      
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('companyId', userId);
    formData.append('fieldName', title);

    const updatedUploadStatus = [...uploadStatus];
    updatedUploadStatus[index] = 'uploading';
    setUploadStatus(updatedUploadStatus);
    try {
      const response = await axios.put('https://www.grcpulse.in/api/ClientsMaterData/uploadClientfile', formData)
     if(response.status === 200){
      const updatedCardStates = [...cardStates];
      updatedCardStates[index].fileUrl = response.data.data;
      updatedCardStates[index].fileName = selectedFile.name;
      setCardStates(updatedCardStates);
      updatedUploadStatus[index] = 'uploaded';
      updatedCardStates[index].isFileModified = true;
      setUploadStatus(updatedUploadStatus);
      setSnackbarOpen(true);
      setSnackbarMessage('File uploaded successfully!');
     
    } 
    else if(response.status === 413){
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage("File size should be below 6MB");
      updatedUploadStatus[index] = 'upload';
      const updatedCardStates = [...cardStates];
      updatedCardStates[index].fileUrl = '';
      updatedCardStates[index].fileName = '';
      updatedCardStates[index].isFileModified = false;
      setCardStates(updatedCardStates);
      setUploadStatus(updatedUploadStatus);
    }
    else if(response.status === 400){
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        updatedUploadStatus[index] = 'upload';
        const updatedCardStates = [...cardStates];
        updatedCardStates[index].fileUrl = '';
        updatedCardStates[index].fileName = '';
        updatedCardStates[index].isFileModified = false;
        setCardStates(updatedCardStates);
        setUploadStatus(updatedUploadStatus);
      }
      else if(response.status === 413){
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage("File size should be below 6MB");
        updatedUploadStatus[index] = 'upload';
        const updatedCardStates = [...cardStates];
        updatedCardStates[index].fileUrl = '';
        updatedCardStates[index].fileName = '';
        updatedCardStates[index].isFileModified = false;
        setCardStates(updatedCardStates);
        setUploadStatus(updatedUploadStatus);
      }
      else if(response.status === 404){
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        updatedUploadStatus[index] = 'upload';
        const updatedCardStates = [...cardStates];
        updatedCardStates[index].fileUrl = '';
        updatedCardStates[index].fileName = '';
        updatedCardStates[index].isFileModified = false;
        setCardStates(updatedCardStates);
        setUploadStatus(updatedUploadStatus);
      }
      else if(response.status === 500){
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        updatedUploadStatus[index] = 'upload';
        const updatedCardStates = [...cardStates];
        updatedCardStates[index].fileUrl = '';
        updatedCardStates[index].fileName = '';
        updatedCardStates[index].isFileModified = false;
        setCardStates(updatedCardStates);
        setUploadStatus(updatedUploadStatus);
      }
  }catch (error) {

      console.error('Error uploading file:', error);
      
      updatedUploadStatus[index] = 'upload';
      setUploadStatus(updatedUploadStatus);
    }

  };

  const handleUploadClick = (index) => {
    fileInputRefs.current[index].current.click();
  };

  const handleInputChange = (e, index) => {
    const { value } = e.target;
    const updatedCardStates = [...cardStates];
    updatedCardStates[index].value = value;
    updatedCardStates[index].clientRemark = ''
   
    setCardStates(updatedCardStates);
  };

   const handleUnitChange = (e, index) => {
    const { value } = e.target;
    const updatedCardStates = [...cardStates];
    updatedCardStates[index].unit = value;
    updatedCardStates[index].clientRemark = ''
   
    setCardStates(updatedCardStates);
  }; 
   const handleFeeChange = (value, index) => {
   
    const updatedCardStates = [...cardStates];
    updatedCardStates[index].fee = value;
    updatedCardStates[index].clientRemark = ''
   
    setCardStates(updatedCardStates);
  };
  const handleRemarkChange = (e,index) => {
    const {value} = e.target;
    const updatedCardStates = [...cardStates];
    updatedCardStates[index].clientRemark = value;
    setCardStates(updatedCardStates);

   
};
  const handleEditClick = (index) => {
    const updatedCardStates = [...cardStates];
    setInitialCardStates(prevStates => {
      const newStates = [...prevStates];
      newStates[index] = { ...cardStates[index] };
      return newStates;
    });
    updatedCardStates[index].editing = true;
    setCardStates(updatedCardStates);
  };

  const handleNotApplicableChange = (index) => {
    const updatedCardStates = [...cardStates];
    updatedCardStates[index].na = !updatedCardStates[index].na;
   

    if (updatedCardStates[index].na) {
     
      updatedCardStates[index].value = '';
      updatedCardStates[index].fileUrl = '';
      updatedCardStates[index].unit = '';

      updatedCardStates[index].fee = '';

      updatedCardStates[index].fileName = '';
      updatedCardStates[index].noOfWorkers = '';
      updatedCardStates[index].validDate = '';
      updatedCardStates[index].clientRemark = ''
      const inputRef = fileInputRefs.current[index];
      if (inputRef && inputRef.current) {
        inputRef.current.value = ''; 
      }
      const updatedUploadStatus = [...uploadStatus];
      updatedUploadStatus[index] = 'upload';
      setUploadStatus(updatedUploadStatus);

    }
    
    setCardStates(updatedCardStates);
  };
  const handleValidDateChange = (value, index) => {
  // Allow clearing the input
  if (value === '') {
    const updatedCardStates = [...cardStates];
    updatedCardStates[index].validDate = '';
    updatedCardStates[index].vendorRemark = '';
    setCardStates(updatedCardStates);
    return;
  }

  // Continue with date format validation
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (!dateRegex.test(value)) {
    return;
  }

  const date = new Date(value);
  if (isNaN(date.getTime())) {
    return;
  }

  const updatedCardStates = [...cardStates];
  updatedCardStates[index].validDate = value;
  updatedCardStates[index].vendorRemark = '';
  setCardStates(updatedCardStates);
};
  const handleNumOfWorkersChange = (value, index) => {
    if(value>=0){
    const updatedCardStates = [...cardStates];
    updatedCardStates[index].noOfWorkers = value;
    updatedCardStates[index].clientRemark = ''
    setCardStates(updatedCardStates);
    }
    else{
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage('Please enter valid number');
      const updatedCardStates = [...cardStates];
    updatedCardStates[index].noOfWorkers = '';
    
    setCardStates(updatedCardStates);
    }
  };
  const handleDateChange = (value, index) => {
    const updatedCardStates = [...cardStates];
    updatedCardStates[index].value = value;
    updatedCardStates[index].clientRemark = ''
    setCardStates(updatedCardStates);
  };

  const handlesave = async (index) => {
    const updatedCardStates = [...cardStates];
    const currentCardState = updatedCardStates[index];

if (currentCardState.fileName && uploadStatus[index] !== 'uploaded') {

  alert('Please upload the file before proceeding further.');

setTimeout(()=>{
  const userConfirmed = window.confirm('Do you want to upload the file now?');
  if (userConfirmed) {
    handleFileUpload(index,currentCardState.fileName);  
  } else {
    updatedCardStates[index].fileName = '';
    updatedCardStates[index].fileUrl = '';
    updatedCardStates[index].editing = false;

    const current = updatedCardStates[index];
    const initial = initialCardStates[index];

    const otherFieldsModified =
      current.value !== initial.value ||
      current.validDate !== initial.validDate ||
      current.noOfWorkers !== initial.noOfWorkers ||
      current.vendorRemark !== initial.vendorRemark ||
      current.fee !== initial.fee ||
      current.na !== initial.na;

    if (!otherFieldsModified) {
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage("No changes detected. Please modify the fields before saving.");
      return;
    }

    setCardStates(updatedCardStates);
    setSnackbarOpen(true);
    setSnackbarMessage('Saving without uploading file');
    setTimeout(()=>{
    handlesave(index)  
    },3500)
  }
},1000)
return;
}

    const updatedValue = currentCardState.value;
    const updatedValidation = 1; 
    const updatedValidDate = currentCardState.validDate;
    const updatedRemark = currentCardState.AssessorRemark;
    const updatedNoOfWorkers = currentCardState.noOfWorkers;
    const updatedClientRemark = currentCardState.clientRemark;
    const updatena = currentCardState.na;
    const updateUnit = currentCardState.unit;
    const updateFee = currentCardState.fee
    const updatedFileUrl = currentCardState.fileUrl;
    const updatedFileUpload = currentCardState.isFileModified;
  
    const initialValues = initialCardStates[index];
    const isModified =
      currentCardState.value !== initialValues.value ||
      (updatedFileUpload && currentCardState.fileUrl !== initialValues.fileUrl) ||
      currentCardState.validDate !== initialValues.validDate ||
      currentCardState.noOfWorkers !== initialValues.noOfWorkers ||
      currentCardState.clientRemark !== initialValues.clientRemark ||
      currentCardState.na !== initialValues.na ||
      currentCardState.fee !== initialValues.fee ||
      currentCardState.unit !== initialValues.unit
  
    if (!isModified) {
      updatedCardStates[index] = { ...initialValues, editing: true };
  
      if (uploadStatus[index] !== 'uploaded') {
        updatedCardStates[index].fileName = '';
        updatedCardStates[index].fileUrl = '';
      } else {
        updatedCardStates[index].fileName = initialValues.fileName || '';
        updatedCardStates[index].fileUrl = initialValues.fileUrl || '';
      }
  
      const updatedUploadStatus = [...uploadStatus];
      updatedUploadStatus[index] = initialValues.fileUrl ? 'uploaded' : 'upload';
  
      setCardStates(updatedCardStates);
      setUploadStatus(updatedUploadStatus);
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage("No changes detected. Please modify the fields before saving.");
      return;
    }
    if (uploadStatus[index] != 'uploaded') {

      if (initialValues.fileUrl) {
        updatedCardStates[index].fileUrl = initialValues.fileUrl; // Use previous fileUrl if file was uploaded before
        updatedCardStates[index].fileName = initialValues.fileName || '';
       
      } else {
        updatedCardStates[index].fileName = '';  // Clear file name if no previous file exists
        updatedCardStates[index].fileUrl = '';   // Clear file URL if no previous file exists
      }
    }
    if (uploadStatus[index] === 'upload') {
      updatedCardStates[index].fileName = '';
      updatedCardStates[index].fileUrl = ''; 
    }
    
    if (uploadStatus[index] === 'uploaded') {
      updatedCardStates[index].fileName = updatedFileUrl ? updatedFileUrl.substring(updatedFileUrl.lastIndexOf('/') + 1) : '';  // Show file name
      updatedCardStates[index].fileUrl = updatedFileUrl; 
    }
    const updatedUploadStatus = [...uploadStatus];
    setCardStates(updatedCardStates);
    setUploadStatus(updatedUploadStatus);
    
     
  
  
   const fieldName = cardStates[index].key; // Index adjusted for 0-based indexing
    
   
  
    const clientMasterData = {
      companyId: userId,
      
      // year:selectedYear,
      [fieldName]: {
        value: updatedValue,
        fileUrl: updatedFileUrl,
        validation: updatedValidation,
        AssessorRemark: updatedRemark,
        Unit: updateUnit,
        clientRemark: updatedClientRemark,
        fee: updateFee,
        na: updatena,
        validDate: updatedValidDate,
        noOfWorkers: updatedNoOfWorkers, 
      }
    };
  
 
  
    try {
      // Call the API to update data
      const response = await api.client.updateClientMasterData(clientMasterData);
      if (response.status === 200) {
        updatedCardStates[index].editing = false;
        updatedCardStates[index].background = COLORS.bggray;
        updatedCardStates[index].validation = 1;
        setCardStates(updatedCardStates);
  
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);

        try {
        // console.log('Calling assessorToMail with payload:', payload);
        const response = await api.client.mailToAssessor({companyId:userId});

        if (response.status === 200) {
          setTimeout(()=>{
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          },2000)
        }
        else if(response.status === 400){
          setTimeout(()=>{
          setErrorSnackbarOpen(true);
          setSnackbarErrorMessage(response.data.message);
          },2000)
        }
         else if(response.status === 404){
          setTimeout(()=>{
          setErrorSnackbarOpen(true);
          setSnackbarErrorMessage(response.data.message);
          },2000)
        }
         else if(response.status === 500){
          setTimeout(()=>{
          setErrorSnackbarOpen(true);
          setSnackbarErrorMessage(response.data.message);
          },2000)
        } else {
          setTimeout(()=>{
          setErrorSnackbarOpen(true);
          setSnackbarErrorMessage(response.data.message);
          },2000)
        }
      } catch (emailErr) {
        console.error('assessorToMail error:', emailErr);
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(emailErr?.response?.data?.message);
      }
      } else if (response.status === 400) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
      } else if (response.status === 404) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
      } else {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage('Error in Updating the data, please try again');
      }
    } catch (error) {
      console.error("Error updating clientMasterData:", error);
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage('Unexpected error occurred. Please try again.');
    }
  };
  
  

const handleFilterChange = async (newFilter,index) => {
  setFilter(newFilter);
  
  setLoading(true);

  try {
    let response;

    if (newFilter === "All") {
    fetchCompanyData(userId)
    } else {
      // Map filter to category
      const apiFilter =
        newFilter === "G"
          ? "Governance"
          : newFilter === "S"
          ? "Social"
          : newFilter === "E"
          ? "Environmental"
          : "All";

      response = await api.client.getByCategory(userId, apiFilter);
    }

    if (response.status === 200) {
      const data = response.data.data;
       const {title} = titles[index]
      const updatedCardStates = Object.keys(data).map((fieldName,index) => ({
       
        key: fieldName,
        title: title,
        Category: data[fieldName].Category || "",
        ...data[fieldName],
        fileName: data[fieldName].fileUrl
          ? data[fieldName].fileUrl.split("/").pop()
          : "",
        background:
          data[fieldName].validation === 2
            ? COLORS.success
            : data[fieldName].validation === 3
            ? COLORS.danger :
              data[fieldName].validation === 1
            ? COLORS.bggray
            : COLORS.light,
      }));
      setCardStates(updatedCardStates);
    }
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};



  const handleCancelButton = (index) => {
    const updatedCardStates = [...cardStates];
    updatedCardStates[index] = initialCardStates[index];
    updatedCardStates[index].editing = false;
    const updatedUploadStatus = [...uploadStatus];
    const initialValues = initialCardStates[index];
    updatedUploadStatus[index] = initialValues.fileUrl ? 'uploaded' : 'upload'; 
   
setCardStates(updatedCardStates);
setUploadStatus(updatedUploadStatus);
  };


        const chunkArray = (array, chunkSize) => {
            const chunkedArray = [];
            for (let i = 0; i < array.length; i += chunkSize) {
              chunkedArray.push(array.slice(i, i + chunkSize));
            }
            return chunkedArray;
          
          };
         
          const chunkedTitles = chunkArray(titles, 3);
          const filteredTitles = chunkedTitles.flat().filter((titleObj) => {
  if (filter === "All") return true;
  return titleObj.Category === filter;
  
});
          const renderInput = (index) => {
            const excludedFeeIndices = [13, 26, 27,28, 29,30, 34,35,36];
          
            // Handle the case for indices that need a 'validDate' and 'numOfWorkers'

let mainFields;

if (
  index === 1 ||
  index === 2 ||
  index === 4 ||
  index === 9 ||
  index === 11 ||
  index === 12 ||
  index === 21 ||
  index === 25 ||
  index === 28 
) {
  // indices that need value + date (+ workers for some)
  mainFields = (
    <>
      {/* Value input */}
      <input
        type="text"
        id="value"
        placeholder="Enter Doc No"
        className="p-2 mb-2"
        style={{ width: "100%", border: "1px solid #eee", borderRadius: "5px" }}
        value={cardStates[index].value}
        onChange={(e) => handleInputChange(e, index)}
        disabled={cardStates[index]?.na}
      />

      {/* Date + Workers logic */}
      {index === 21 || index === 25 ? (
        <section className="d-flex justify-content-between">
          <input
            type="date"
            id="validDate"
            placeholder="Valid Date"
            className="p-2 mb-2"
            style={{ width: "100%", border: "1px solid #eee", borderRadius: "5px" }}
            value={cardStates[index].validDate}
            onChange={(e) => handleValidDateChange(e.target.value, index)}
            disabled={cardStates[index].na}
          />
          <input
            type="number"
            id="numOfWorkers"
            placeholder="No Of Workers"
            className="p-2 mb-2"
            style={{ width: "100%", border: "1px solid #eee", borderRadius: "5px" }}
            value={cardStates[index].noOfWorkers}
            onChange={(e) => handleNumOfWorkersChange(e.target.value, index)}
            disabled={cardStates[index].na}
            min="0"
          />
        </section>
      ) : (
        <input
          type="date"
          id="validDate"
          placeholder="Valid Date"
          className="p-2 mb-2"
          style={{ width: "100%", border: "1px solid #eee", borderRadius: "5px" }}
          value={cardStates[index].validDate}
          onChange={(e) => handleValidDateChange(e.target.value, index)}
          disabled={cardStates[index].na}
        />
      )}
    </>
  );
} else {
  // other indices: only value input
  mainFields = (
    <div className="mb-1">
      <input
        type="text"
        placeholder="Enter Doc No"
        id="value"
        className="p-2"
        style={{ width: "100%", border: "1px solid #eee", borderRadius: "5px" }}
        value={cardStates[index].value}
        onChange={(e) => handleInputChange(e, index)}
        disabled={cardStates[index].na}
      />
    </div>
  );
}

// ✅ Always return main fields + fee (unless excluded)
return (
  <>
    {mainFields}

    {index < 37 && !excludedFeeIndices.includes(index) && (
      <>
      <input
        type="text"
        id="fee"
        placeholder={`Value`}
        className="p-2 mb-2"
        style={{ width: "100%", border: "1px solid #eee", borderRadius: "5px" }}
        value={cardStates[index].fee}
        onChange={(e) => {
      let rawValue = e.target.value.replace(/,/g, ""); // remove existing commas
      if (/^\d*$/.test(rawValue)) { // only allow numbers
        const formatted = rawValue.replace(/\B(?=(\d{3})+(?!\d))/g, ","); 
        handleFeeChange(formatted, index); 
      }
    }}
        disabled={cardStates[index]?.na}
      />
        <input
        type="text"
        id="unit"
        placeholder="Enter Unit"
        className="p-2 mb-2"
        style={{ width: "100%", border: "1px solid #eee", borderRadius: "5px" }}
        value={cardStates[index].unit}
        onChange={(e) => handleUnitChange(e, index)}
        disabled={cardStates[index]?.na}
      />
      </>
    )}
  </>
);

            }
          
        
          
          
      
  return (
    <>
    {loading ? (
      <div className="d-flex flex-row align-items-center justify-content-center" style={{ marginTop: '80px' }}>
      <h3>Loading</h3>
<div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div> 
<div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
<div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>

</div>
   ) : (
    <div style={{ overflow: 'hidden' }}>
  
        <div className="mt-4 mb-3 d-md-flex " style={{ justifyContent: 'space-between' }} >
  
          <Snackbar
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            severity="success"
            open={snackbarOpen}
            autoHideDuration={2000}
            onClose={() => setSnackbarOpen(false)}
             sx={{
              marginTop: '2.9%', 
              marginRight: '7%'
            }}
          >
            <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
          </Snackbar>
          <Snackbar
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            severity="success"
            open={errorSnackbarOpen}
            autoHideDuration={2000}
            onClose={() => {setErrorSnackbarOpen(false)}}
            sx={{
              marginTop: '2.9%', 
              marginRight: '7%'
            }}
          >
            <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
          </Snackbar>
  
          <div style={{ letterSpacing: '1px' }}>
             <div style={{ backgroundColor: COLORS.bggray, width: '15px', height: '15px', display: 'inline-block', marginRight: '4px', marginLeft: '8px', borderRadius: '50%' }}></div> 
            <span style={{ fontSize: '14px' }}>Under review : {countValidation1}</span> 
            <div className="vr  mx-3"></div>
            <div style={{ backgroundColor: COLORS.success, width: '15px', height: '15px', display: 'inline-block', marginRight: '4px', borderRadius: '50%' }}></div>
            <span style={{ fontSize: '14px' }}>Accepted : {countValidation2}</span>
            <div className="vr mx-3"></div>
            <div style={{ backgroundColor: COLORS.danger, width: '15px', height: '15px', display: 'inline-block', marginRight: '4px', borderRadius: '50%' }}></div>
            <span style={{ fontSize: '14px' }}>Rejected : {countValidation3}</span> 
          </div>
  
        </div>
        <section className='d-grid'>
        <div className='d-flex justify-content-end mb-3 mx-3'>
    {/* <select className='mx-1 p-1' style={{border:'1px solid lightgray',borderRadius:'4px', cursor:'pointer'}} value={selectedYear} onChange={handleYearChange} >
                        <option value="" disabled>Select Year</option>
                        {years.map((year) => (
                            <option key={year} value={year}>
                                {year}
                            </option>
                        ))}
                    </select> */}
                    <select className="p-1" value={filter} onChange={(e)=> handleFilterChange(e.target.value)} style={{border:'1px solid lightgray'}}>
  <option value="All">All</option>
  <option value="Governance">Governance</option>
  <option value="Social">Social</option>
  <option value="Environmental">Environmental</option>
</select>

                    </div>
        <div style={{ minHeight:'420px',maxHeight: "400px",overflowY: "auto" }}>
       <table>
  <thead className="position-sticky top-0 text-center table-dark" style={{ zIndex: 10 }}>
    <tr className='text-white bg-dark'>
      <th>Name of DOC</th>
      <th>Category</th>
      <th>Input</th>
      <th>Actions</th>
      <th>Uploaded File</th>
      <th>Status</th>
      <th>Assessor Remark</th>
    </tr>
  </thead>
<tbody>
  {cardStates
    .map((card, index) => ({ ...card, index })) // keep original index
    .filter(card => {
      if (filter === "All") return true;
      if (filter === "Governance") return card.Category === "Governance";
      if (filter === "Social") return card.Category === "Social";
      if (filter === "Environmental") return card.Category === "Environmental";
      return true;
    })
    .map(card => {
      const index = card.index;

      const validationText =
        card.validation === 1
          ? "Under Review"
          : card.validation === 2
          ? "Accepted"
          : card.validation === 3
          ? "Rejected"
          : "Not Uploaded";

      return (
        <tr key={card.key} style={{ backgroundColor: card.background }}>
          {/* Title */}
          <td>{card.title}</td>
          <td className='text-secondary'>
            {card.Category === "Governance"
              ? "Governance"
              : card.Category === "Social"
              ? "Social"
                : card.Category === "Environmental"
              ? "Environment"
              : ""}
          </td>

          {/* Input Fields */}
          <td style={{ minWidth: "300px" }}>
            {card.editing ? (
              <>
                <Form.Check
                  className='d-flex gap-2 float-end'
                  label="Not Applicable"
                  checked={card.na}
                  onChange={() => handleNotApplicableChange(index)}
                />
                {renderInput(index)}
                <Form.Control
                  type="text"
                  className="mt-1"
                  placeholder={`Upload Proof for ${card.title}`}
                  value={card.fileName || ''}
                  readOnly
                  disabled={card.na}
                />
                <div className="d-flex float-end mt-2 mb-2 gap-2">
                  <button className="btn btn-sm btn-outline-primary" disabled={card.na}>
                    <BiUpload onClick={() => handleUploadClick(index)} />
                  </button>
                  <Button
                    variant="light"
                    style={{ border: "1px solid gray" }}
                    disabled={card.na || uploadStatus[index] === 'uploading' || uploadStatus[index] === 'uploaded'}
                    onClick={() => handleFileUpload(index, card.title)}
                  >
                    {uploadStatus[index] === 'uploading'
                      ? 'Uploading...'
                      : uploadStatus[index] === 'uploaded'
                      ? 'Uploaded'
                      : 'Upload'}
                  </Button>
                  <input
                    type="file"
                    style={{ display: 'none' }}
                    onChange={(e) => handleFileChange(e, index)}
                    ref={fileInputRefs.current[index]}
                  />
                </div>

                <textarea
                  className="form-control mt-3"
                  rows="2"
                  placeholder="Enter your remarks here"
                  value={card.clientRemark}
                  onChange={(e) => handleRemarkChange(e, index)}
                />
              </>
            ) : (
              <div style={{ maxHeight: '150px', width: '320px', overflowY:'auto', display:'grid', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', maxWidth: '250px' }}>
                  {card.value && <div><strong>Doc No:</strong> <span>{card.value}</span></div>}
                  {card.fee && <div><strong>Value:</strong> <span>{card.fee}</span></div>}
                  {card.unit && <div><strong>Unit:</strong> <span>{card.unit}</span></div>}
                  {card.validDate && <div><strong>Valid Date:</strong> {card.validDate.slice(0, 10).split('-').reverse().join('-')}</div>}
                  {card.noOfWorkers && <div><strong>No of Workers:</strong> <span>{card.noOfWorkers}</span></div>}
                  {card.na && !card.value && !card.fileUrl && <div><strong>Status:</strong> Not Applicable</div>}
                  {card.clientRemark && (
                    <div style={{ border: '1px solid #ccc', borderRadius: '4px', padding: '6px', backgroundColor: '#f9f9f9', minHeight: '60px', maxHeight: '120px', overflowY: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                      <strong>Remark:</strong>
                      <div>{card.clientRemark}</div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </td>

          {/* Actions */}
          <td>
            {!card.editing ? (
              <button className="btn btn-outline-danger btn-sm" onClick={() => handleEditClick(index)}>
                Upload/Edit
              </button>
            ) : (
              <div className="d-flex flex-column gap-2">
                <button className="btn btn-outline-secondary btn-sm" onClick={() => handleCancelButton(index)}>Cancel</button>
                <button
                  className="btn btn-sm btn-dark"
                  onClick={() => handlesave(index)}
                  disabled={!(card.value || card.fileUrl || card.na || card.fee || card.unit || card.validDate || card.noOfWorkers)}
                >
                  Save
                </button>
              </div>
            )}
          </td>

          {/* Uploaded File */}
          <td>
            {card.fileUrl && (
              <div className="d-flex justify-content-center gap-3">
                <button className="flex flex-col items-center text-sm text-green-700" onClick={() => window.open(`https://docs.google.com/gview?url=${card.fileUrl}&embedded=true`, '_blank')}>
                  <MdFileOpen className="text-xl text-success" /> View
                </button>
                <a download className='flex flex-col items-center text-sm text-blue-700' href={card.fileUrl}>
                  <FaFileDownload className="text-xl text-primary" /> Download
                </a>
              </div>
            )}
          </td>

          {/* Validation Status */}
          <td>{validationText}</td>

          {/* Assessor Remark */}
          <td>
            {card.AssessorRemark && (
              <div style={{ border: '1px solid #ccc', borderRadius: '4px', padding: '6px', backgroundColor: '#f9f9f9', minHeight: '60px', maxHeight: '120px', overflowY: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {card.AssessorRemark}
              </div>
            )}
          </td>
        </tr>
      );
    })}
</tbody>

</table>

        </div>
        </section>
      </div>
   )}
      </>
  )
}

export default MasterDataClient
